/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/SetupAction/Content/Content/Content/Title"
  
}) {
let appNameValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'name',
})
let globalCurrentLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.name',
})
let stepsStepsValueData = fromData.useDataValue({ viewPath,
context: 'steps',
path: 'steps',
})
let aggregateData = fromHelpers.getText(appNameValueData, globalCurrentLocationNameValueData, stepsStepsValueData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 weight="medium"
 whiteSpace="normal"
 color={dtColorsNeutral900}
 data="app.name"
 data="global.current_location.name"
 data="steps.steps"
 aggregate="helpers.js getText"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}